
function hasMethod (obj, name) {
    const desc = Object.getOwnPropertyDescriptor (obj, name);
    return !!desc && typeof desc.value === 'function';
  }

export default class ReceiptSearchParams{
    constructor(params){
        this.maxCount = "";
        this.id = "";
        this.gcid = ""
        this.startDate = "";
        this.endDate = "";
        this.inspector = "";
        this.location = "";
    }




    asQueryString(){
        var obj = {
            "maxcount": this.maxCount,
            "schemaid": this.schemaId,
            "id": this.id,
            "gcid": this.gcid,
            "location": this.location,
            "inspector": this.inspector,
            "startdate": this.startDate,
            "enddate": this.endDate
        }
        var allKeysWithValues = [];
        Object.keys(obj).forEach(function(key) {
            if (obj[key] === undefined) return;
            if (obj[key] === "" || obj[key]==="ALL" || obj[key]==="all") return;
            allKeysWithValues.push(key + '=' +  obj[key]);
        });
          var result = allKeysWithValues.join('&');
          return result;
    }


    validate(){
        return true;
    }
}